module.exports = __webpack_public_path__ + "media/images/b2b_admin/mailer/modal_to_edit_role-3ee57b4d1f93179d8ec3a12279522e59.png";